$breakpoints: (xl, lg, md, sm, xs, xxs);

.signet-menu {
  position: relative;
  display: inline-block;
  line-height: 1;

  &.mega-menu {
    display: inline-block;
    position: static;
  }

  &.harmony{
    font-family: 'Enterprise Sans';
    .menu-button{
      background-color: #E9F1FF00;
      border-radius: 0;
      border-color: #E9F1FF00;
      border-bottom: solid 3px #E9F1FF00;
      color: #002677;
      padding: 0 !important;
      align-items: center;
      min-height: 48px;
      &:hover {
          background-color: #E5E5E6;
          border-bottom: solid 3px #002677;
          color: unset;
        }

      .menu-icon {
        line-height: 1;
        transition: all 0.3s ease-in-out;
        border-left: solid 1px;
        background-color: transparent;
        border-color: transparent;
        padding: 0 8px;
        display: flex;
        align-items: center;
        margin-left: 0;
        color: #002677;
        .icon {
          margin: 0 -4px;
        }
        &:hover {
          background-color: unset;
          color: unset;
          opacity: unset
        }
      }
      .menu-text{
        font-family: 'Enterprise Sans';
        font-size: 14px;
        text-transform:none;
      }
    }
    &.show-contents {
        .menu-button {
          background-color: #E5E5E6;
          border-bottom: solid 3px #002677;
        }
    }
    .menu-contents {
      font-size: 14px;
      border-radius: 8px;
        .menu-item {
          padding: 8px 16px;
          cursor: pointer;
          border-top: solid 1px #E9F1FF00;
          border-bottom: solid 1px #E9F1FF00;
          color: #4B4D4F;
          &:hover {
            background-color: #E9F1FF;
            border-top: solid 1px #0C55B8;
            border-bottom: solid 1px #0C55B8;
          }
        }
        
    }
    
  }

  

  .menu-button {
    white-space: nowrap;
    display: flex;
    align-items: center;
    background-color: transparent;
    border-color: --var(--action-default);
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border: 1px solid;
    border-color: var(--action-default);
    color: var(--action-default);
    background-color: transparent;
    padding: 0 !important;
    align-items: stretch;

    

    .icon {
      margin-right: 2px;
    }

    .menu-text {
      padding: 6px 0px 6px 16px;
    }

    .menu-icon {
      line-height: 1;
      transition: all 0.3s ease-in-out;
      border-left: solid 1px;
      border-color: var(--action-default);
      padding: 0 5px;
      display: flex;
      align-items: center;
      margin-left: 16px;

      .icon {
        margin: 0 -4px;
      }

      &:hover {
        background-color: var(--primary-main);
        color: var(--pure-white);
        opacity: 60%;
      }
    }

    .secondary-menu-icon {
      line-height: 1;
      transition: all 0.3s ease-in-out;
      padding: 0 5px;
      display: flex;
      align-items: center;

      .icon {
        margin: 0 -4px;
      }
    }
  }

  .menu-contents {
    display: flex;
    flex-direction: column;
    visibility: hidden;
    opacity: 0;
    left: 0;
    position: absolute;
    list-style: none;
    overflow: scroll;
    white-space: nowrap;
    width: 100%;
    overflow-x: auto;
    transform: translateY(-0.25rem);
    background-color: white;
    border-radius: 4px;
    z-index: 10;
    padding: 8px 0;
    transition: all 0.3s ease-in-out;

    .menu-item {
      padding: 8px;
      cursor: pointer;

      &:hover {
        background-color: var(--gray-100);
      }

      > * {
        display: inline-block;
      }

      a {
        text-align: left;
        text-decoration: none;
        display: block;
        width: 100%;
        font-weight: normal;
        color: var(--text-primary);
        font-size: 16px;
      }
    }

    &.align-left {
      left: 0;
      right: auto;
      // border-top-left-radius: 0;
    }

    &.align-right {
      right: 0;
      left: auto;
      // border-top-right-radius: 0;
    }
  }

  .mega-menu-contents {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    float: none;
    left: 0;
    right: 0;
    max-width: 100%;
    min-width: 200px;
    overflow-y: auto;
    transform: translateY(-0.25rem);
    background-color: white;
    border-radius: 4px;
    z-index: 10;
    padding: 0 8px;
    padding-top: 0px;
    padding-bottom: 0px;
    margin: 0;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
  }

  &.show-contents {
    .contents {
      visibility: visible;
      opacity: 1;
      transform: translateY(0rem);
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.12);
      transition: all 0.3s ease-in-out;
    }

    .menu-contents {
      display: flex;
      flex-direction: column;
      min-width: fit-content;
    }

    .helpertext-container {
      // position: absolute;
      padding-top: 2px;
      padding-left: 8px;
      padding-bottom: 6px;
      cursor: default;

      p {
        font-size: 12px;
        color: var(--gray-500);
      }
    }
  }
  &.show-contents .menu-icon {
    background-color: var(--primary-main);
    color: var(--pure-white);
    opacity: 60%;
  }
}
